"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueRootCausesApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssueRootCausesApi = exports.IssueRootCausesApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: () => api.getAll("issue-root-cause-categories?limit=9999&include=rootcauses"),
    create: (issueRootCauseCategoryId, attributes) => api.create("issue-root-cause-categories/".concat(issueRootCauseCategoryId, "/issue-root-causes"), attributes),
    update: (issueRootCauseId, attributes) => api.update("issue-root-causes/".concat(issueRootCauseId), attributes),
    delete: issueRootCauseId => api.delete("issue-root-causes/".concat(issueRootCauseId)),
    Categories: {
      create: attributes => api.create("issue-root-cause-categories?include=rootcauses", attributes),
      update: (issueRootCauseCategoryId, attributes) => api.update("issue-root-cause-categories/".concat(issueRootCauseCategoryId, "?include=rootcauses"), attributes),
      delete: issueRootCauseCategoryId => api.delete("issue-root-cause-categories/".concat(issueRootCauseCategoryId))
    }
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.INVALIDATE_ALL_QUERIES
});
//# sourceMappingURL=IssueRootCausesApi.js.map